import { Component } from "react";
import Form from "react-bootstrap/Form";
import FormText from "react-bootstrap/FormText";
import ValidationResult from "../common/ValidationResult";
import { ClipLoader } from "react-spinners";
import "../steps/forms.scss";

export default class OrderFormStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
      hasDataChanged: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onRadioChange = this.onRadioChange.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.shouldDisplay = this.shouldDisplay.bind(this);
  }

  loadCart() {
    // intended to override
  }

  onSelect(e, id) {
    let formState = this.state.formState;
    formState[id].value = e.value;
    this.setState({
      formState: formState,
      hasDataChanged: true,
    });
  }

  onInputChange(e, id) {
    let formState = this.state.formState;
    formState[id].value = e.target.value;
    this.setState({
      formState: formState,
      hasDataChanged: true,
    });

    this.loadCart();
  }

  onCheckboxChange(e, id, name) {
    let formState = this.state.formState;

    if (id) {
      formState[name].value[parseInt(id)] = e.target.checked;
    } else {
      formState[name].value = e.target.checked;
    }
    this.setState({
      formState: formState,
      hasDataChanged: true,
    });

    this.loadCart();
  }

  onRadioChange(e, name) {
    let formState = this.state.formState;
    formState[name].value = parseInt(e.target.value);
    this.setState({
      formState: formState,
      hasDataChanged: true,
    });

    this.loadCart();
  }

  hasDataChanged() {
    return this.state.hasDataChanged;
  }

  validateData() {
    let result = new ValidationResult();
    let formState = this.state.formState;
    for (let key in formState) {
      let field = formState[key];
      field.failedRequiredValidation =
        field.isRequired &&
        (field.value === "" || field.value === 0 || field.value === null);
      result.isValid &= !field.failedRequiredValidation;
    }
    this.setState({ formState: formState });
    if (!result.isValid) {
      result.errorMessage = "Missing data in required fields";
    }
    return result;
  }

  makeLoadingText() {
    return (
      <div className="loader">
        <ClipLoader color="#000000" size={40} />
      </div>
    );
  }

  makeFormControl(props = {}) {
    return (
      <Form.Control
        as={props.as}
        type={props.type}
        onChange={this.onInputChange}
        ref={(input) => {
          if (input === null) return;
          this.applyRequiredClass(input);
          this.setValueFromState(input);
        }}
      >
        {props.options}
      </Form.Control>
    );
  }

  makeRadioButtonList(props = {}, applyRequiredClass = true) {
    return (
      <div
        id={props.id}
        className="padded"
        ref={(container) => {
          if (container === null) return;
          if (applyRequiredClass) {
            this.applyRequiredClass(container);
          }
        }}
      >
        {props.data.map((item) => {
          return (
            <div key={item[props.valueField]}>
              <Form.Check
                type="radio"
                name={props.id}
                value={item[props.valueField]}
                label={item[props.textField]}
                checked={this.isRadioChecked(item, props)}
                onChange={this.onRadioChange}
                style={{ display: "inline" }}
              />
              {props.secondaryTextField ? (
                <FormText style={{ paddingLeft: "2em" }}>
                  {item[props.secondaryTextField].join(" + ")}
                </FormText>
              ) : null}
            </div>
          );
        })}
      </div>
    );
  }

  makeCheckBoxList(props = {}) {
    return (
      <div className="padded">
        {props.data.map((item) => {
          return (
            <div key={item[props.valueField]}>
              <Form.Check
                type="checkbox"
                name={props.id}
                value={item[props.valueField]}
                label={item[props.textField]}
                checked={this.isCheckboxChecked(item, props)}
                onChange={this.onCheckboxChange}
              />
              {props.secondaryTextField ? (
                <FormText style={{ paddingLeft: "2em" }}>
                  {item[props.secondaryTextField].join(" + ")}
                </FormText>
              ) : null}
            </div>
          );
        })}
      </div>
    );
  }

  applyRequiredClass(input) {
    let fieldState = this.state.formState[input.id];
    if (fieldState.isRequired) {
      const emptyInputStr = " emptyInput";
      if (fieldState.failedRequiredValidation) {
        if (!input.className.includes(emptyInputStr)) {
          input.className += emptyInputStr;
        }
      } else {
        input.className = input.className.replace(emptyInputStr, "");
      }
    }
  }

  setValueFromState(input) {
    input.value = this.state.formState[input.id].value;
  }

  isRadioChecked(item, props) {
    return item[props.valueField] === this.state.formState[props.id].value;
  }

  isCheckboxChecked(item, props) {
    return this.state.formState[props.id].value[item[props.valueField]];
  }

  async shouldDisplay(formTypeId) {
    return true;
  }
}
